import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TODAS LAS CATEGORIAS
export const obtenerCategorias = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Categorias`, "GET");
  return respuesta;
};

// OBTENER TODAS LAS CATEGORIAS ACTIVAS
export const obtenerCategoriasAct = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Categorias/CategoriasAct`, "GET");
  return respuesta;
};

// MODIFICAR CATEGORIA
export const modificarCategoria = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Categorias/add`,
    "POST",
    data
  );
  return respuesta;
};

// AGREGAR CATEGORIA
export const addCategoria = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Categorias/add`,
    "POST",
    data
  );
  return respuesta;
};
